export default {
  state: {
    defaultModalData: {
      status: false,
      data: {},
    },
  },

  getters: {
    getDefaultModalData(state) {
      return state.defaultModalData;
    },
  },

  mutations: {
    setDefaultModal(state, infos) {
      state.defaultModalData.status = infos.status;

      const isEmpty = Object.keys(infos.data).length === 0;
      if (!isEmpty) {
        state.defaultModalData.data = infos.data;
      }
    },
  },

  actions: {
    changeDefaultModal(context, infos) {
      context.commit("setDefaultModal", infos);
    },
  },
};
